import { useCallback } from 'react';

import { GA4_EVENT_VIEW_ITEM_LIST } from '@/data/constants/gtm';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { isB2BStore, useSettings } from '@/data/Settings';
import { logEventWithValues } from '@/data/utils/logEventsUtils';
import { useMobileApp } from '@/utils/useMobileApp';
import { B2B, B2C } from 'presentation/events/constants/eventConstants';
import { useCurrentPhysicalStoreId } from 'presentation/events/hooks/useCurrentPhysicalStoreId';
import { buildGA4ViewItemListEventPayload } from 'presentation/events/hooks/useTrackViewItemList/utils';
import { triggerGA4EcommerceEvent } from 'presentation/events/services/ga4EcommerceService';
import { SendViewItemListEventProps } from './types';

export const useTrackViewItemListGA4 = () => {
	const { settings } = useSettings();
	const { physicalStoreId } = useCurrentPhysicalStoreId();
	const { isMobileApp } = useMobileApp();
	const isB2B = isB2BStore(settings);

	return useCallback(
		(props: SendViewItemListEventProps) => {
			const { ga4 } = getGTMConfig(settings);

			if (!ga4 || !physicalStoreId) return;

			const payload = buildGA4ViewItemListEventPayload({
				event: GA4_EVENT_VIEW_ITEM_LIST,
				settings,
				physicalStoreId,
				items: props.products.map(({ product, categories, quantity }) => ({
					product,
					categories,
					quantity,
				})),
				itemListId: props.listId,
				itemListName: props.listPageName,
			});

			if (!isMobileApp) {
				triggerGA4EcommerceEvent(payload);
				return;
			}

			const mobilePayload = {
				...payload.ecommerce,
				app_thd: !isB2B ? B2C : B2B,
			};
			logEventWithValues(payload.event, mobilePayload);
		},
		[isB2B, isMobileApp, physicalStoreId, settings]
	);
};
